import React, { Component } from 'react';
import { HashLink as Link } from 'react-router-hash-link';

import renderHTML from 'react-render-html';
import PropTypes from 'prop-types';

const parsingRules = {
  St: [
    /St. /g, 'STPLACEHOLDER', 'St. ',
  ],
  US: [
    /U\.S\./g, 'USPLACEHOLDER', 'U.S.',
  ],
};

const applyRules = (text) => {
  let parsedText = text;
  Object.values(parsingRules).forEach((rule) => {
    parsedText = parsedText.replace(new RegExp(rule[0]), rule[1]);
  });
  return parsedText;
};

const revertRules = (text) => {
  let parsedText = text;
  Object.values(parsingRules).forEach((rule) => {
    parsedText = parsedText.replace(new RegExp(rule[1], 'g'), rule[2]);
  });
  return parsedText;
};

const parseText = (text, query) => {
  const parsedQuery = query.trim();
  let parsedText = renderHTML(text).replace(/<\s*iframe[^>]*>(.*?)<\s*\/\s*iframe>/g, ' [Spotify] ');
  parsedText = applyRules(parsedText);

  const lines = parsedText.split('.');
  const output = [];
  lines.forEach((line) => {
    const newLine = revertRules(line);
    output.push(`${newLine.trim()}.`);
  });


  let result = '';
  for (let i = 0; i < output.length; i += 1) {
    if (output[i].toLowerCase().includes(parsedQuery.trim().toLowerCase())) {
      const spanText = (parsedQuery[0] === parsedQuery[0].toUpperCase()
        ? `${parsedQuery[0]}${parsedQuery.toLowerCase().slice(1)}`
        : parsedQuery.toLowerCase());
      output[i] = output[i].replace(new RegExp(parsedQuery, 'gi'), `<span style="background-color: yellow">${spanText}</span>`);
      result = output[i];
    }
  }
  result = result.replace(/figcaption<span/g, '');
  result = result.replace(/figcaptio<span/g, '');
  result = result.replace(/figcapti<span/g, '');
  result = result.replace(/figcapt<span/g, '');
  result = result.replace(/figcap<span/g, '');
  result = result.replace(/figca<span/g, '');
  result = result.replace(/figc<span/g, '');
  result = result.replace(/fig<span/g, '');
  result = result.replace(/fi<span/g, '');
  result = result.replace(/f<span/g, '');
  result = result.replace(/jpg" \/>/g, '');
  return result;
};

export default class Result extends Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: true,
    };
  }

  render() {
    const {
      title,
      image,
      text,
      query,
      url,
    } = this.props;

    const { loading } = this.state;

    const parsedText = parseText(text, query);
    const valid = (image.length > 'https://static.yourworldapps.nl/apptool/'.length);

    return (
      <Link to={url} >
        <div className="search__result--item">
          <div className="search__result--header">
            {valid &&
            <img
              style={{ opacity: loading ? 0 : 1 }}
              src={image}
              alt={image}
              onLoad={() => {
                this.setState({ loading: false });
              }}
            />}
            <h4>{title}</h4>
          </div>
          <p>{renderHTML(parsedText)}</p>
        </div>
      </Link>
    );
  }
}


Result.propTypes = {
  title: PropTypes.string.isRequired,
  image: PropTypes.string,
  text: PropTypes.string.isRequired,
  query: PropTypes.string.isRequired,
  url: PropTypes.string,
};

Result.defaultProps = {
  image: '',
  url: '',
};